export enum ButtonType {
    INLINE_STYLE_BUTTON = 0xB0,
    BLOCK_TYPE_BUTTON,
    BLOCK_TYPE_CUSTOM,
}